import { useEffect } from "react";
import Lenis from "lenis";
import "@/App.css";
import { initAnalytics } from "@/analytics";
import { TopMarquee } from "@/components/landing/TopMarquee";
import { Navbar } from "@/components/landing/Navbar";
import { Hero } from "@/components/landing/Hero";
import { WhatIsMapSection } from "@/components/landing/WhatIsMapSection";
import { NotSalesSection } from "@/components/landing/NotSalesSection";
import { ForWhoSection } from "@/components/landing/ForWhoSection";
import { StorySection } from "@/components/landing/StorySection";
import { MethodSection } from "@/components/landing/MethodSection";
import { FaqSection } from "@/components/landing/FaqSection";
import { FinalCtaSection } from "@/components/landing/FinalCtaSection";
import { Footer } from "@/components/landing/Footer";
import { StickyCta } from "@/components/landing/StickyCta";

function App() {
  useEffect(() => {
    initAnalytics();
    const lenis = new Lenis({ duration: 1.15, smoothWheel: true });
    window.__lenis = lenis;
    let raf;
    const loop = (time) => {
      lenis.raf(time);
      raf = requestAnimationFrame(loop);
    };
    raf = requestAnimationFrame(loop);
    return () => {
      cancelAnimationFrame(raf);
      lenis.destroy();
      window.__lenis = null;
    };
  }, []);

  return (
    <div className="bg-ink font-sans text-white">
      <div className="noise-overlay" aria-hidden />
      <div className="sticky top-0 z-50">
        <TopMarquee />
        <Navbar />
      </div>
      <main>
        <Hero />
        <WhatIsMapSection />
        <NotSalesSection />
        <ForWhoSection />
        <StorySection />
        <MethodSection />
        <FaqSection />
        <FinalCtaSection />
      </main>
      <Footer />
      <StickyCta />
    </div>
  );
}

export default App;
